// const hostApi = process.env.NODE_ENV === "development" ? "http://localhost" : "https://sing-generator-node.herokuapp.com";
// const portApi = process.env.NODE_ENV === "development" ? 8080 : "";
// const baseURLApi = `${hostApi}${portApi ? `:${portApi}` : ``}/api`;
// const redirectUrl = process.env.NODE_ENV === "development" ? "http://localhost:3000/sing-app-react" : "https://demo.flatlogic.com/sing-app-react";

const defaultHostApi = process.env.NODE_ENV === "development"
  ? "http://localhost:5000"
  : "https://posapi-dev.rebelity.com";
const hostApi = (process.env.REACT_APP_API_BASE_URL || defaultHostApi).replace(/\/$/, "");
const portApi = process.env.NODE_ENV === "development" ? "" : "";
const baseURLApi = `${hostApi}${portApi ? `:${portApi}` : ``}`;

const defaultPayrollAppUrl = process.env.NODE_ENV === "development"
  ? "http://localhost:5174"
  : "https://payroll.rebelity.com";
const payrollAppUrl = (process.env.REACT_APP_PAYROLL_APP_URL || defaultPayrollAppUrl).replace(/\/$/, "");

export default {
  hostApi,
  portApi,
  storageURL: "https://rebelity-pos-images.s3.amazonaws.com",
  baseURLApi,
  payrollAppUrl,
  // Stripe publishable key used by the POS Online (Stripe Elements) payment mode.
  // Leave empty to disable online card payments — Terminal mode still works.
  stripePublishableKey: process.env.REACT_APP_STRIPE_PK || '',
  auth: {
    email: 'darkwat2',
    password: 'Jenifek1'
  },
  app: {
    colors: {
      dark: "#002B49",
      light: "#FFFFFF",
      sea: "#004472",
      sky: "#E9EBEF",
      wave: "#D1E7F6",
      rain: "#CCDDE9",
      middle: "#D7DFE6",
      black: "#13191D",
      salat: "#21AE8C",
    },
  }
};